import DeviceSuggestionCard from '../DeviceSuggestionCard'
import useViewModel from './VehicleSuggestionCard.viewmodel'

export type Props = Parameters<typeof useViewModel>[0]

const { SettingsSuggestions, SuggestionCard, SuggestionDescription } =
  DeviceSuggestionCard

export default function VehicleSuggestionCard(props: Props) {
  const viewModel = useViewModel(props)
  const {
    isLoadingOrIdle,
    dayOfWeekScheduleDescription,
    limitsText,
    goalsDescriptions,
    displayName,
    settingPaths,
    articles,
    settingsWhitelist,
  } = viewModel

  if (isLoadingOrIdle) {
    return null
  }

  return (
    <DeviceSuggestionCard
      iconName="PlainVehicle"
      title={displayName}
      articles={articles}
    >
      {settingsWhitelist.length > 0 && (
        <SettingsSuggestions>
          {settingsWhitelist.includes('charge-schedule') && (
            <SuggestionCard
              iconName="Clock"
              title="Charge schedule"
              destinationPath={settingPaths.chargeSchedule}
            >
              <div className="flex flex-col">
                {dayOfWeekScheduleDescription.map((description) => (
                  <SuggestionDescription key={description}>
                    {description}
                  </SuggestionDescription>
                ))}
              </div>
            </SuggestionCard>
          )}
          {settingsWhitelist.includes('charge-limits') && (
            <SuggestionCard
              iconName="BatteryCharging"
              title="Charge limits"
              destinationPath={settingPaths.limits}
            >
              <SuggestionDescription>{limitsText}</SuggestionDescription>
            </SuggestionCard>
          )}
          {settingsWhitelist.includes('charge-goals') && (
            <SuggestionCard
              iconName="Target"
              title="Goals"
              destinationPath={settingPaths.goals}
            >
              <div className="flex flex-col">
                {goalsDescriptions.enabledPlans.length === 0 ? (
                  <SuggestionDescription>
                    No goals selected
                  </SuggestionDescription>
                ) : (
                  goalsDescriptions.enabledPlans.map((plan) => (
                    <SuggestionDescription key={plan}>
                      {plan}: Enabled
                    </SuggestionDescription>
                  ))
                )}
              </div>
            </SuggestionCard>
          )}
        </SettingsSuggestions>
      )}
    </DeviceSuggestionCard>
  )
}
